import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {

  constructor(private http: HttpClient) { }


  addTimesheetCategory(data,categEditID): Observable<any> {
    if(!categEditID){
      return this.http.post<any>(`${environment.apiUrl}/timesheet/add_timesheet_cat`, data);
    }else{
      return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_timesheet_cat_action`, data);
    }
  }

  cateoryGet(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/timesheet/get_timesheet_cat`);
  }

  editCategory(catID): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_timesheet_cat/` + catID);
  }

  editCatStatus(stat, catID): Observable<any> {
    const option = {
      status: stat,
      cat_id : catID
  };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_timesheet_cat_status`, options);
  }

  deleteCategory(catID): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/timesheet/delete_timesheet_cat`, {cat_id: catID});
  }

  getCategory(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/timesheet/select_categories`);
  }

  SubCategoryGet():Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/timesheet/get_timesheet_subcat`);
  }
  addTimesheetSubcat(data,subcategEditID):Observable<any>{
    if(!subcategEditID){
      return this.http.post<any>(`${environment.apiUrl}/timesheet/add_timesheet_subcat`,data);
    }else{
      return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_timesheet_subcat_action`, data);
    }
  }
  editSubCategory(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_timesheet_subcat/` + id);
  }
  
  editSubCatStatus(stat, subcatID): Observable<any> {
    const option = {
      status: stat,
      subcat_id : subcatID
  };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_timesheet_subcat_status`, options);
  }

  deleteSubCategory(subcatID) :Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/timesheet/delete_timesheet_subcat`, {subcat_id: subcatID});
  }

  getActiveCategory():Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/timesheet/select_categories`);

  }

  addTimesheetTask(data,editTaskID):Observable<any>{
  if(!editTaskID)
  {
    return this.http.post<any>(`${environment.apiUrl}/timesheet/add_task_action`, data);
  }else{
    return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_task_action`, data);
  }
  }

  editTimesheetTask(editTaskID): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_issue_tracker/` + editTaskID);
  }

  addAppGroup(data: FormData, appGrpID): Observable<any> {
    if (!appGrpID) {
      return this.http.post<any>(`${environment.apiUrl}/setups/app-menu/add_application_grp`, data);
    } else {
      return this.http.post<any>(`${environment.apiUrl}/setups/app-menu/edit_application_grp_action`, data);
    }
  }

  getAllTask(data):Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_task`,{params: param});
  }

  editAllTasks(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_all_task/` + id);
  }
  
  deleteTask(editTask) :Observable<any> {
      return this.http.post<any>(`${environment.apiUrl}/timesheet/delete_task`, {id: editTask});
    }

    monthDuration():Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_wrk_duration`);
    }

    getWrkSummry(id):Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_duration/` + id);

    }

    addIssueTracker(data): Observable<any>{
    return this.http.post<any>(`${environment.apiUrl}/timesheet/add_issue_tracker_action`, data);
    }

    updateIssueTracker(data): Observable<any>{
      return this.http.post<any>(`${environment.apiUrl}/timesheet/update_issue_tracker_action`, data);
      }

    getIssueTracker(data): Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_issue_tracker`,{params:param});
    }

    getMyTicket(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data.forms) {
        if (
          data.forms[key] !== '' &&
          data.forms[key] !== undefined &&
          data.forms[key] !== null
        ) {
          param = param.append(key, data.forms[key]);
        }
      }
  
      if (
        'page' in data &&
        data.page !== '' &&
        data.page !== undefined
      ) {
        param = param.append('page', data.page);
      }
      if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
        param = param.append('limit', data.limit);
      }
      return this.http.get(`${environment.apiUrl}/timesheet/get_my_ticket`, {
        params: param,
      });
    }

    getOwnershipTicket(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data.forms) {
        if (
          data.forms[key] !== '' &&
          data.forms[key] !== undefined &&
          data.forms[key] !== null
        ) {
          param = param.append(key, data.forms[key]);
        }
      }
  
      if (
        'page' in data &&
        data.page !== '' &&
        data.page !== undefined
      ) {
        param = param.append('page', data.page);
      }
      if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
        param = param.append('limit', data.limit);
      }
      
      return this.http.get(`${environment.apiUrl}/timesheet/get_ownership_ticket`, {
        params: param,
      });
    }
    addAssignTicket(data: FormData, appGrpID): Observable<any> {
      return this.http.post<any>(`${environment.apiUrl}/timesheet/add_assign_ticket`, data);
    }
    myTicketAction(data: FormData, appGrpID): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/timesheet/my_ticket_action`, data);
    }
    getMobileTeam(): Observable<any> {
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_mobilise_team`
      );
    }

    getGeneralTicketStatus(): Observable<any> {
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_gen_ticket_status`
      );
    }
    getMyTicketActionStatus(): Observable<any> {
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_my_ticket_action_status`
      );
    }
    getAssignTicketStatus(): Observable<any> {
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_assign_ticket_status`
      );
    }

    getAssignedTicket(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data.forms) {
        if (
          data.forms[key] !== '' &&
          data.forms[key] !== undefined &&
          data.forms[key] !== null
        ) {
          param = param.append(key, data.forms[key]);
        }
      }
  
      if (
        'page' in data &&
        data.page !== '' &&
        data.page !== undefined
      ) {
        param = param.append('page', data.page);
      }
      if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
        param = param.append('limit', data.limit);
      }
      
      return this.http.get(`${environment.apiUrl}/timesheet/get_assigned_ticket`, {
        params: param,
      });
    }

    getSeachTicket(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data.forms) {
        if (
          data.forms[key] !== '' &&
          data.forms[key] !== undefined &&
          data.forms[key] !== null
        ) {
          param = param.append(key, data.forms[key]);
        }
      }
  
      if (
        'page' in data &&
        data.page !== '' &&
        data.page !== undefined
      ) {
        param = param.append('page', data.page);
      }
      if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
        param = param.append('limit', data.limit);
      }
      
      return this.http.get(`${environment.apiUrl}/timesheet/get_search_ticket`, {
        params: param,
      });
    }

    getIssueTrackerClient(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data.forms) {
        if (
          data.forms[key] !== '' &&
          data.forms[key] !== undefined &&
          data.forms[key] !== null
        ) {
          param = param.append(key, data.forms[key]);
        }
      }
  
      if (
        'page' in data &&
        data.page !== '' &&
        data.page !== undefined
      ) {
        param = param.append('page', data.page);
      }
      if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
        param = param.append('limit', data.limit);
      }
      
      return this.http.get(`${environment.apiUrl}/timesheet/get_issue_tracker_client`, {
        params: param,
      });
    }

    getDeveloperName():Observable<any>{
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_developer_name`);
    }
    getWorkDuration(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_work_duration`,{params:param});
    }

    getWorkDeatils(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_work_details`,{params:param});
    }

    getTimesheetReport(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_timesheet_report`,{params:param});
    }

    getAllProject(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_project`,{params: param});
    }

    addProject(data,editTaskID):Observable<any>{
      if(!editTaskID)
      {
        return this.http.post<any>(`${environment.apiUrl}/timesheet/add_project_action`, data);
      }else{
        return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_project_action`, data);
      }
    }

    editAllProjects(id): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_all_project/` + id);
    }

    deleteProject(editProject) :Observable<any> {
      return this.http.post<any>(`${environment.apiUrl}/timesheet/delete_project`, {id: editProject});
    }

    getAllApplication(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_application`,{params: param});
    }

    addApplication(data,appEditID):Observable<any>{
      if(!appEditID)
      {
        return this.http.post<any>(`${environment.apiUrl}/timesheet/add_application_action`, data);
      }else{
        return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_application_action`, data);
      }
    }

    editAllApplication(id): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_all_project/` + id);
    }

    getAllMenu(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_menu`,{params: param});
    }

    addMenu(data,appEditID):Observable<any>{
      if(!appEditID)
      {
        return this.http.post<any>(`${environment.apiUrl}/timesheet/add_menu_action`, data);
      }else{
        return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_menu_action`, data);
      }
    }

    editAllMenu(id): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_all_menu/` + id);
    }

    getAllSubMenu(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/timesheet/get_all_sub_menu`,{params: param});
    }

    addSubMenu(data,appEditID):Observable<any>{
      if(!appEditID)
      {
        return this.http.post<any>(`${environment.apiUrl}/timesheet/add_sub_menu_action`, data);
      }else{
        return this.http.post<any>(`${environment.apiUrl}/timesheet/edit_sub_menu_action`, data);
      }
    }
    editAllSubMenu(id): Observable<any> {
      return this.http.get<any>(`${environment.apiUrl}/timesheet/edit_all_sub_menu/` + id);
    }
    getSetupActionPermission(): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}/timesheet/setup_action_permission`);
    }

    getWorkDurationReport(data): Observable<any> {
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(
        `${environment.apiUrl}/timesheet/get_work_duration_report`,{params:param});
    }

    cateoryDashboard(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/mis-reports/category_wise_timesheet_report`,{params: param});
    }

    spendDashboard(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/mis-reports/overall_time_spend`,{params: param});
    }

    attendceDashboard(data):Observable<any>{
      let param = new HttpParams();
      for (const key in data) {
        if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
          param = param.append(key, data[key]);
        }
      }
      return this.http.get<any>(`${environment.apiUrl}/mis-reports/emp_monthly_attendce_report`,{params: param});
    }
}
